import { dateFormatter } from '@/helpers/dateFormatter'
import { IBaseChanges } from './model'
import { PassportStatus } from '@/typings/api/PassportList'

interface IChangesStatus extends IBaseChanges {
  context: {
    from: boolean | string | null;
    to: boolean | string | null;
  };
}

const getType = (v: IBaseChanges['action_type']) => {
  switch (v) {
    case 'activate':
      return 'Изменение состояния паспорта'
    case 'changed_contexts':
      return 'Изменение контекстных данных'
    case 'status_updated':
      return 'Изменение статуса паспорта'
    case 'ate_api_updated':
      return 'Изменение данных в АПИ АТЕ'
    default:
      return v
  }
}

const getStatusStr = (v: IChangesStatus['context']['from' | 'to'] | undefined) => {
  if (typeof v === 'undefined' || v === null) {
    return '-'
  }

  if (typeof v === 'string') {
    switch (v) {
      case PassportStatus.inProgress:
        return 'В работе'
      case PassportStatus.submitted:
        return 'Сдано'
      case PassportStatus.notStarted:
        return 'Не приступал'
      default:
        return v
    }
  }

  return v ? 'Активный' : 'Не активный'
}

export const STATUS_CHANGES_HEADERS = [
  {
    text: 'Тип',
    value: 'action_type',
    sortable: false,
    field: (value: IBaseChanges['action_type']) => getType(value),
  },
  {
    text: 'Пользователь',
    value: 'username',
    sortable: false,
  },
  {
    text: 'Дата изменения',
    value: 'created_at',
    sortable: false,
    field: (value: IBaseChanges['created_at']) => (
      value && dateFormatter(value)
    ),
  },
  {
    text: 'Было',
    value: 'context_from',
    sortable: false,
    getValue: (v: IChangesStatus) => getStatusStr(v.context?.from),
  },
  {
    text: 'Стало',
    value: 'context_to',
    sortable: false,
    getValue: (v: IChangesStatus) => getStatusStr(v.context?.to),
  },
]
